export const userMarkerSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
  <path fill="#FFF" d="M14 24a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"/>
  <path fill="#3780D6" d="M14 21a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"/>
</svg>
`;

// eslint-disable-next-line import/no-default-export
export default userMarkerSvg;
